import { SVGAttributes } from 'react'

export const Suite = (props: SVGAttributes<SVGElement>) => (
  <svg {...props} viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M24.54 37.9419L24.54 41.5332"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.7372 28.365V22.3795C25.7372 21.0572 26.8091 19.9853 28.1314 19.9853H40.1024C41.4247 19.9853 42.4966 21.0572 42.4966 22.3795V28.365"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43.0953 28.365C41.4424 28.365 40.1025 29.7049 40.1025 31.3577V33.1534H28.1315V31.3577C28.1315 29.7049 26.7916 28.365 25.1387 28.365C23.4859 28.365 22.146 29.7049 22.146 31.3577C22.146 32.8056 23.1742 34.0133 24.5402 34.2906V37.9418H43.6938V34.2906C45.0599 34.0133 46.088 32.8056 46.088 31.3577C46.088 29.7049 44.7481 28.365 43.0953 28.365Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43.6938 37.9419L43.6938 41.5332"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5693 41.5332H16.1606M19.7519 41.5332H16.1606M16.1606 41.5332L16.1606 23.5767M16.1606 18.7883V23.5767M16.1606 23.5767H8.97803L12.5693 13.9999L19.7519 13.9999L23.3432 23.5767L16.1606 23.5767Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
